import { Component, OnInit } from '@angular/core';
import { EMailService } from '../../services/email.service';
import { EDeliveryService } from '../../services/edelivery.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, combineLatest } from 'rxjs';
import { AgreementService } from '../../services/agreement.service';
// import { debounceTime } from 'rxjs/operators';
import { Email } from '../../models/e-mail.model';
import { Inject, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LogService, PershingHttpUtil } from '@pershing/pershing-core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { EdeliveryLabels } from '../../i18n/edelivery-labels';
import { PershingTranslationService } from '@pershing/pershing-core';
import { OneClickEnrollCancelComponent } from '../oneClickEnrollCancel/one-click-enroll-cancel.component';
import { AgreementComponent } from '../agreement/agreement.component';

@Component({
  selector: 'modern-one-click-enroll',
  templateUrl: './one-click-enroll.component.html',
  styleUrls: ['./one-click-enroll.component.css']
})
export class ModernOneClickEnrollComponent implements OnInit {

  // emailResponse: Observable<Emailresponse>;
  // emailSubscription: Subscription;
  private combinedSubscription: Subscription;
  // confirmEmail: string = '';
  errorMessage: string;
  oneClickEnrollEmail1: string = '';
  oldEmail1: string = '';
  oneClickEnrollEmail2: string = '';
  oldEmail2: string = '';
  emailSeq1: number = -1;
  emailSeq2: number = -1;
  emailsToBeSubmitted: Email[];
  email1 = new Email(null);
  email2 = new Email(null);
  log: LogService;
  closePopup: boolean = false;
  emails: Email[] = [];
  showInterstitial: boolean = false;
  goPaperless: boolean = false;
  suppressOneClickEnrollCancel: boolean = false;
  userFromMyClientView: boolean = false;
  ibdNumber: string;

  // Labels
  emailLabel = EdeliveryLabels.ONE_CLICK_ENROLL_EMAIL_PLACEHOLDER;
  invalidEmailAddress = EdeliveryLabels.INVALID_EMAIL;
  invalidEmailAddressMaxLength = EdeliveryLabels.INVALID_EMAIL_MAXLENGTH;
  acceptLabel = EdeliveryLabels.ACCEPT;
  remindMeLaterLabel = EdeliveryLabels.REMIND_ME_LATER;
  oneClickEnrollHeaderDescription1 = EdeliveryLabels.ONE_CLICK_ENROLL_HEADER_DESCRIPTION1;
  oneClickEnrollHeaderDescription2 = EdeliveryLabels.ONE_CLICK_ENROLL_HEADER_DESCRIPTION2;
  oneClickEnrollHeaderDescription3 = EdeliveryLabels.ONE_CLICK_ENROLL_HEADER_DESCRIPTION3;
  oneClickEnrollEmailAddress1 = EdeliveryLabels.ONE_CLICK_ENROLL_EMAIL_ADDRESS1;
  oneClickEnrollEmailAddress2 = EdeliveryLabels.ONE_CLICK_ENROLL_EMAIL_ADDRESS2;
  oneClickEnrollFooterDescription1 = EdeliveryLabels.ONE_CLICK_ENROLL_FOOTER_DESCRIPTION1;
  oneClickEnrollFooterDescription2 = EdeliveryLabels.ONE_CLICK_ENROLL_FOOTER_DESCRIPTION2;
  
  emailForm = new FormGroup({
    'oneClickEnrollEmail1': new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.maxLength(64),
      Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
    ]),
    'oneClickEnrollEmail2': new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.maxLength(64),
      Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
    ])
  });

  backgroundImgPath;
  mobileBackgroundImgPath;
  backgroundStyle;
  mobileBackgroundStyle;

  constructor(private emailService: EMailService, private edeliveryService: EDeliveryService,
              private agreementService: AgreementService,
              public dialog: MatDialog,
              public dialogRef: MatDialogRef<ModernOneClickEnrollComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
              log: LogService,
              private translate: PershingTranslationService,
              private route: ActivatedRoute,
              @Optional() @Inject('AppSettings') appSettings: any) {
    // let i = 0;
    this.log = log;
    if (data.showInterstitial !== undefined) {
      this.showInterstitial = data.showInterstitial;
    }
    if (data.goPaperless !== undefined) {
      this.goPaperless = data.goPaperless;
    }
    if (data.suppressOneClickEnrollCancel !== undefined) {
      this.suppressOneClickEnrollCancel = data.suppressOneClickEnrollCancel;
    }
    if (appSettings.ibdConfigMap) {
        this.userFromMyClientView = !!appSettings.isAdvisor ? appSettings.isAdvisor : false;
        this.ibdNumber = appSettings.ibdConfigMap.IBD;
    }
    // log.info(data.email);
    // this.emails = data.emails;
    // for (const email of this.emails) {
    //   i++;
    //   if (i === 1) {
    //     this.oldEmail1 = email.emailAddress;
    //     this.emailForm.get('oneClickEnrollEmail1').setValue(email.emailAddress);
    //     // this.emailForm.get('confirmEmail1').setValue(email.emailAddress);
    //     this.oneClickEnrollEmail1 = email.emailAddress;
    //     this.emailSeq1 = email.emailSeqNum;
    //   } else if (i === 2) {
    //     this.oldEmail2 = email.emailAddress;
    //     this.emailForm.get('oneClickEnrollEmail2').setValue(email.emailAddress);
    //     // this.emailForm.get('confirmEmail2').setValue(email.emailAddress);
    //     this.oneClickEnrollEmail2 = email.emailAddress;
    //     this.emailSeq2 = email.emailSeqNum;
    //   }
    // }
    // this.emailsToBeSubmitted = data.emails;
    if (this.translate) {
      this.translate.addTranslationFolder('@pershing/edc-newedelivery', 'node_modules/@pershing/edc-newedelivery/lib');
    }
    this.backgroundImgPath = PershingHttpUtil.resolveResourcePath('@pershing/edc-newedelivery',
                'node_modules/@pershing/edc-newedelivery/lib/assets/edel-one-click-enroll.jpg', appSettings);
    this.mobileBackgroundImgPath = PershingHttpUtil.resolveResourcePath('@pershing/edc-newedelivery',
                'node_modules/@pershing/edc-newedelivery/lib/assets/edel-one-click-enroll-mobile.jpg', appSettings);
    this.backgroundStyle = {
      "background": "linear-gradient(270deg, #F9F9F9 50%, transparent 100%), url('" + this.backgroundImgPath + "') left no-repeat",
      "background-size": "cover"
    }
    this.mobileBackgroundStyle = {
      "background": "linear-gradient(0deg, #F9F9F9 70%, transparent 100%), url('" + this.mobileBackgroundImgPath + "') center top / contain no-repeat"
    }
  }

  ngOnInit() {
    this.emailService.retrieveEmails();
    this.combinedSubscription = combineLatest(this.emailService.emailresponse$, this.route.queryParamMap)
      // .pipe(debounceTime(1000))
      .subscribe(([emailResponse, routeResponse]) => {
        if (emailResponse && routeResponse) {
          this.emails = emailResponse.emails;
          let i = 0;
          for (const email of this.emails) {
            i++;
            if (i === 1) {
              this.oldEmail1 = email.emailAddress;
              this.emailForm.get('oneClickEnrollEmail1').setValue(email.emailAddress);
              // this.emailForm.get('confirmEmail1').setValue(email.emailAddress);
              this.oneClickEnrollEmail1 = email.emailAddress;
              this.emailSeq1 = email.emailSeqNum;
            } else if (i === 2) {
              this.oldEmail2 = email.emailAddress;
              this.emailForm.get('oneClickEnrollEmail2').setValue(email.emailAddress);
              // this.emailForm.get('confirmEmail2').setValue(email.emailAddress);
              this.oneClickEnrollEmail2 = email.emailAddress;
              this.emailSeq2 = email.emailSeqNum;
            }
          }
          // if (routeResponse.get('showInterstitial') === 'true') {
          //   this.showInterstitial = true;
          // }
        }
      });

  //   this.emailSubscription = this.emailService.emailresponse$.subscribe(response => {
  //     if (response) {
  //         this.emails = response.emails;
  //         let i = 0;
  //         for (const email of this.emails) {
  //           i++;
  //           if (i === 1) {
  //             this.oldEmail1 = email.emailAddress;
  //             this.emailForm.get('oneClickEnrollEmail1').setValue(email.emailAddress);
  //             // this.emailForm.get('confirmEmail1').setValue(email.emailAddress);
  //             this.oneClickEnrollEmail1 = email.emailAddress;
  //             this.emailSeq1 = email.emailSeqNum;
  //           } else if (i === 2) {
  //             this.oldEmail2 = email.emailAddress;
  //             this.emailForm.get('oneClickEnrollEmail2').setValue(email.emailAddress);
  //             // this.emailForm.get('confirmEmail2').setValue(email.emailAddress);
  //             this.oneClickEnrollEmail2 = email.emailAddress;
  //             this.emailSeq2 = email.emailSeqNum;
  //           }
  //         }
  //     }
  // });
    // this.log.info(this.oneClickEnrollEmail1, this.oneClickEnrollEmail2);
    // console.log('current emails: ', this.currentEmails);
    // this.emailResponse = this.emailService.emailresponse$;
  }

  ngOnDestroy() {
    // this.emailSubscription.unsubscribe();
    if (this.combinedSubscription) {
      this.combinedSubscription.unsubscribe();
    }
  }

  saveEmail(): void {
    this.oneClickEnrollEmail1 = this.emailForm.value.oneClickEnrollEmail1.toUpperCase();
    this.oneClickEnrollEmail2 = this.emailForm.value.oneClickEnrollEmail2.toUpperCase();
    // this.confirmEmail = this.emailForm.value.confirmEmail.toUpperCase();
    console.log('Emails: ', this.oneClickEnrollEmail1, this.oneClickEnrollEmail2);
    if (this.oneClickEnrollEmail1.trim() === '' && this.oneClickEnrollEmail2.trim() === '') {
      this.errorMessage = 'At least one eDelivery Email is required';
      return;
    }

    if (this.oneClickEnrollEmail1 !== undefined && this.oneClickEnrollEmail2 !== undefined) {
      if (this.oneClickEnrollEmail1.trim().toUpperCase() === this.oneClickEnrollEmail2.trim().toUpperCase()) {
        this.errorMessage = 'Only one valid e-mail address is required. If you choose to provide more than' +
                          ' the one required address, each e-mail you enter must be distinct from the previous entry.';
        if (this.translate.translate.store.currentLang === 'es') {
            this.errorMessage = 'Solo se requiere una dirección de correo electrónico válida.' +
            ' Si elige proporcionar más que la dirección requerida,' +
            ' cada correo electrónico que ingrese debe ser diferente de la entrada anterior.';
        }
        return;
      }
   }

   if (this.userFromMyClientView) {
     this.close();
     return;
   }

   if ((this.oneClickEnrollEmail1 !== undefined && this.oneClickEnrollEmail1.trim() !== '') ||
      (this.oldEmail1 !== undefined && this.oldEmail1.trim() !== '')) {
      this.email1.emailAddress = this.oneClickEnrollEmail1;
      this.email1.oldEmailAddress = this.oldEmail1;
      if (this.emailSeq1 !== -1) {
        this.email1.emailSeqNum = this.emailSeq1;
        this.email1.emailIndex = this.emailSeq1;
      }
      // this.emailsToBeSubmitted.push(this.email1);
    }
    if ((this.oneClickEnrollEmail2 !== undefined && this.oneClickEnrollEmail2.trim() !== '') ||
      (this.oldEmail2 !== undefined && this.oldEmail2.trim() !== '')) {
      this.email2.emailAddress = this.oneClickEnrollEmail2;
      this.email2.oldEmailAddress = this.oldEmail2;
      if (this.emailSeq2 !== -1) {
        this.email2.emailSeqNum = this.emailSeq2;
        this.email2.emailIndex = this.emailSeq2;
      }
      // this.emailsToBeSubmitted.push(this.email2);
    }
    this.emailsToBeSubmitted = [this.email1, this.email2];
    this.emailService.oneClickEnroll(this.emailsToBeSubmitted);
    this.emailService.showEmailPopup = false;
    this.edeliveryService.triggerLoadingIcon(true);
    this.emailService.updateEmailTriggered = true;
    document.dispatchEvent(new CustomEvent('portal.nxiOneClickAcceptEvent'));
    this.close();
    // this.closePopup = true;
  }
  close() {
    this.dialogRef.close();
  }
  oneClickEnrollCancel(emails: Email[]): void {
    if (this.ibdNumber === 'EDW' || this.ibdNumber === '6KB' || this.suppressOneClickEnrollCancel) {
      if (this.userFromMyClientView) {
        this.dialogRef.close();
        return;
      }
      if (!this.goPaperless) {
        this.agreementService.remindMeLaterAgreement();
      }
      this.dialogRef.close();
    } else {
      if (!this.goPaperless) {
        this.dialog.open(OneClickEnrollCancelComponent, {data: this.dialogRef, panelClass: ['modal', 'edel-OneClickEnrollCancel'], disableClose: true});
      } else {
        this.dialogRef.close();
      }
    }
  }
  goToAgreement() {
    // this.edeliveryService.goToAgreement();
    this.agreementService.enableBackToEnrollment = true;
    this.dialog.open(AgreementComponent, {data: true, panelClass: ['modal', 'edel-OneClickEnroll_TC'], disableClose: true});
  }
}
